import React from "react";
import styled from "styled-components";

import MarketingLink from "./MarketingLink";
import { colours } from "../../utils";
import Device from "../../utils/device";
import { FunctionComponent } from "react";

type StyleProps = {
  backgroundColour?: string;
  colour?: string;
  title?: string | string[] | React.ReactNode;
};

type FloatingTextBoxProps = {
  colour: string;
  copy: string;
  linkText: string;
  linkUrl: string;
  animationColour?: string;
  backgroundColour?: string;
  download?: boolean;
  subTitle?: {
    start: string;
    italic: string;
    end: string;
  };
  title?: string | string[] | React.ReactNode;
  target?: string;
};

const FloatingTextBox: FunctionComponent<FloatingTextBoxProps> = (props) => {
  return (
    <S.Container {...props} data-cy="floating-text-box">
      {!!props.subTitle && (
        <S.Subtitle {...props}>
          {props.subTitle.start} <i>{props.subTitle.italic}</i>{" "}
          {props.subTitle.end}
        </S.Subtitle>
      )}
      {!!props.title && <S.Title>{props.title}</S.Title>}
      <S.Copy>{props.copy}</S.Copy>
      <MarketingLink
        animationColour={props.animationColour}
        href={props.linkUrl}
        linkText={props.linkText}
        download={props.download}
        target={props.target}
      />
    </S.Container>
  );
};

export default FloatingTextBox;

const S = () => {};

S.Container = styled.article<StyleProps>`
  position: relative;
  width: 100%;
  box-shadow: -20px 20px 0 0 ${(p) => p.colour};
  background: ${(p) => p.backgroundColour || colours.shell};
  padding: ${(p) => (p.title ? "10% 10%" : "10%")};
  display: flex;
  flex-direction: column;
  align-items: ${(p) => (p.title ? "center" : "start")};
  gap: 30px;
  text-align: ${(p) => (p.title ? "center" : "start")};

  @media (min-width: ${Device.mobile}) {
    padding: ${(p) => (p.title ? "10% 10% 10% 10%" : "10%")};
  }
`;

S.Subtitle = styled.p<StyleProps>`
  color: ${(p) => p.colour};
  font-family:
    Roxborough CF,
    sans-serif;
  font-size: 2rem;
`;

S.Title = styled.h3`
  font-family:
    Roxborough CF,
    sans-serif;
  font-weight: 100;
  font-size: 3rem;
  line-height: 3rem;

  @media (${Device.mobile}) {
    font-size: 4rem;
    line-height: 4rem;
  }

  @media (${Device.tablet}) {
    font-size: 5rem;
    line-height: 5rem;
  }
`;

S.Copy = styled.p`
  font-size: 1.5rem;

  @media (${Device.mobile}) {
    font-size: 1.7rem;
  }
`;
